import * as React from 'react';
import bind from 'apmui/decorators/bind';
import OktaVerify from './OktaVerify';
import SharedSecret from './SharedSecret';
import SmsEmailOption from './SmsEmailOption';
import { IOktaMfaModel, IVerifyEventModel, UPDATE } from './Model';

interface IOktaEnrollProps {
    okta: IOktaMfaModel;
    callback: (data: IVerifyEventModel) => void;
}

interface IOktaEnrollState {
    step: number;
    enableBackBtn: boolean;
}

class OktaEnroll extends React.Component<IOktaEnrollProps, IOktaEnrollState> {
    state = {
        step: 1,
        enableBackBtn: true,
    };

    @bind
    onClick() {
        const { state } = this.props.okta.oktaMfa;
        if (!state.isMoreOption) {
            const data: IVerifyEventModel = {
                type: UPDATE,
                factor: 'isMoreOption',
                value: true,
            };
            this.props.callback(data);
            return;
        }
        if (this.state.step == 2) {
            this.setState({ step: 1 });
            this.showEnrollFactorsBtn(true);
            return;
        }
        this.showEnrollFactorsBtn(false);
        this.setState({ step: 2 });
    }
    @bind
    disableBackBtn() {
        this.setState({ enableBackBtn: false });
    }

    @bind
    showEnrollFactorsBtn(show: boolean) {
        const data: IVerifyEventModel = {
            factor: 'showEnrollPageBtn',
            type: UPDATE,
            value: show,
        };
        this.props.callback(data);
    }

    render() {
        const { strings } = this.props.okta.oktaMfa;
        const rt = this.props.okta.oktaMfa.state;
        let backBtn = null;
        if (this.state.step === 1) {
            const instruction = strings.oktaVerifySetup;
            const showSecret = rt.isPush ? false : true;
            const qrCode = <SharedSecret okta={this.props.okta} showSecret={showSecret} />;
            const cantScanBtn = rt.isPush && (
                <span className="button-container">
                    <input
                        type="submit"
                        className="apmui-button apmui-button-long"
                        id="submit"
                        name="submit"
                        value={strings.moreOptionsToEnroll}
                        onClick={this.onClick}
                    />
                </span>
            );
            const nextBtn = !rt.isPush && (
                <span className="button-container">
                    <input
                        type="submit"
                        className="apmui-button apmui-button-submit apmui-button-long"
                        id="submit"
                        name="submit"
                        value={strings.next}
                        onClick={this.onClick}
                    />
                </span>
            );
            return (
                <div>
                    <p>{instruction}</p>
                    {qrCode}
                    {cantScanBtn}
                    {nextBtn}
                </div>
            );
        }
        backBtn = rt.isPush && this.state.enableBackBtn && (
            <span className="button-container">
                <input
                    type="submit"
                    className="apmui-button apmui-button-long"
                    id="submit"
                    name="submit"
                    value={strings.back}
                    onClick={this.onClick}
                />
            </span>
        );
        const nextPage = rt.isPush ? (
            <SmsEmailOption
                okta={this.props.okta}
                callback={this.props.callback}
                disableBackBtn={this.disableBackBtn}
            />
        ) : (
            <OktaVerify okta={this.props.okta} onClick={this.props.callback} />
        );
        return (
            <div>
                {nextPage}
                {backBtn}
            </div>
        );
    }
}

export default OktaEnroll;
